function getSessionIdFromCookieOrStorage() {
  const cookieMatch = /(?:^|; )session_id=([^;]*)/.exec(document.cookie);
  const cookieSessionId = cookieMatch?.[1] ? decodeURIComponent(cookieMatch[1]).trim() : '';

  if (cookieSessionId && cookieSessionId !== 'undefined' && cookieSessionId !== 'null') {
    return cookieSessionId;
  }

  const storageSessionId = localStorage.getItem('session_id');
  if (storageSessionId && storageSessionId !== 'undefined' && storageSessionId !== 'null') {
    return storageSessionId;
  }

  return null;
}

export async function getStudyInstanceAPI(viewer_token) {
  // const apiUrl = `https://vidaa-api-test.bcn-medtech-apps.upf.edu/viewers/ohif/${project}/${caseId}`;
  //const apiUrl = `https://vidaa-api.virtest.eu/viewers/ohif`;

  const API_URL_ENV = process.env.API_URL;
  const API_URL = `${API_URL_ENV}/viewers/ohif`;

  //const token = params.get('vidaatoken');

  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  const normalizedViewerToken =
    viewer_token && viewer_token !== 'undefined' && viewer_token !== 'null' ? viewer_token : null;
  if (normalizedViewerToken) {
    myHeaders.append('Authorization', `Bearer ${normalizedViewerToken}`);
  }

  const session_id = getSessionIdFromCookieOrStorage();
  if (session_id) {
    myHeaders.append('x-api-key', session_id);
  }

  try {
    const response = await fetch(API_URL, {
      method: 'GET',
      headers: myHeaders,
      credentials: 'include',
    });

    const data = await response.json();
    console.log('Study info:', data);

    // Note: The segmentation loaded state is now managed by SegmentationStateProvider
    // instead of localStorage. Initialize it to false on app start.
    // The provider will update this state when a segmentation is actually loaded.

    return data;
  } catch (error) {
    console.error('Error fetching study info:', error);
  }
}
